import { useMountEffect } from '@direct-frontend/stdlib';
import { useCallback } from 'react';

export interface UseFilterExpressionInputParams {
    /**
     * Ref, который нужно передать внутрь FilterExpressionInput
     */
    ref: React.RefObject<HTMLTextAreaElement>;

    /**
     * Необходимо ли сфокусироваться на этом компоненте сразу же при его монтировании
     */
    autoFocus?: boolean;

    /**
     * Колбэк, вызывающийся при автофокусе
     */
    onAutoFocus?: () => void;
}

export const useFilterExpressionInput = (params: UseFilterExpressionInputParams) => {
    const { ref, autoFocus, onAutoFocus } = params;

    const focus = useCallback(() => {
        // setTimeout нужен, чтобы дождаться закрытия попапа, так как он захватывает фокус
        setTimeout(() => ref.current?.focus(), 0);
    }, [ref]);

    useMountEffect(() => {
        if (autoFocus) {
            focus();
            onAutoFocus?.();
        }
    });

    return {
        focus,
    };
};
